module.exports = __webpack_public_path__ + "static/media/payrollupload.766d406c.svg";